import { configureStore } from "@reduxjs/toolkit";
import { rootSaga as apiSaga } from "EntitiesApi/Sagas";
import { beneficiaryPairsApi } from "Features/BeneficiaryPairs";
import { employeeHealthAccountApi } from "Features/EmployeeHealthAccounts";
import { individualApplicationApi } from "IndividualApplication";
import { individualLifeApi } from "IndividualLife/api";
import honeybadgerMiddleware from "Redux/Middleware/honeybadgerMiddleware";
import { reducer as formReducer } from "redux-form";
import createSagaMiddleware from "redux-saga";
import { fork } from "redux-saga/effects";

import { redirectOnErrorMiddleware } from "Common/Redux/middleware";
import { siteConfigSlice } from "Common/Redux/siteConfig";

import { employeeApplicationApi } from "./api";
import navigationSaga from "./navigationSaga";

import { accountApi } from "Care/features/account";

const constantReducer = (initial) => (x) => (typeof x === "undefined" ? initial : x);

export const reducerSlices = {
  form: formReducer,
  employeeHashId: constantReducer(""),
  [employeeApplicationApi.reducerPath]: employeeApplicationApi.reducer,
  [employeeHealthAccountApi.reducerPath]: employeeHealthAccountApi.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [individualLifeApi.reducerPath]: individualLifeApi.reducer,
  [individualApplicationApi.reducerPath]: individualApplicationApi.reducer,
  [beneficiaryPairsApi.reducerPath]: beneficiaryPairsApi.reducer,
  [siteConfigSlice.name]: siteConfigSlice.reducer,
};

const sagaMiddleware = createSagaMiddleware();

function* rootSaga() {
  yield fork(apiSaga);
  yield fork(navigationSaga);
}

const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActionPaths: [
            "meta.baseQueryMeta.request",
            "meta.baseQueryMeta.response",
            "meta.arg.originalArgs.bornAt",
            "meta.arg.originalArgs.employeeForm.hiredAt",
          ],
        },
      })
        .concat(sagaMiddleware)
        .concat(honeybadgerMiddleware)
        .concat(employeeApplicationApi.middleware)
        .concat(employeeHealthAccountApi.middleware)
        .concat(accountApi.middleware)
        .concat(individualLifeApi.middleware)
        .concat(individualApplicationApi.middleware)
        .concat(beneficiaryPairsApi.middleware)
        .concat(redirectOnErrorMiddleware),
    preloadedState,
  });

  sagaMiddleware.run(rootSaga);
  return store;
};

export default createStore;
